import DashboardLayout from '@/components/feature/DashboardLayout';
import OreeMarketViewRd from './OreeMarketViewRd';

/**
 * Каркас сторінок «Торгівля» — РЕДИЗАЙН.
 *
 * Копія стандартної компоновки §4 дизайн-контракту: повноширинна підкладка
 * var(--bg), контент у max-w-[1440px], Urbanist, заголовок font-display.
 * Спільний для /trading, /trading/dam і /trading/idm — вони відрізняються лише
 * підписами та фільтром ринку.
 */
export default function TradingRdFrame({ title, subtitle, breadcrumb, marketFilter }: {
  /** Не передавати, коли назву розділу вже показує топбар — тоді блок
   *  заголовка не рендериться взагалі (див. /trading). */
  title?: string;
  subtitle?: string;
  /** Назва розділу для топбара (останній елемент — поточна сторінка). */
  breadcrumb: string[];
  marketFilter: 'DAM' | 'IDM' | null;
}) {
  return (
    <DashboardLayout breadcrumb={breadcrumb}>
      <div className="min-h-screen -m-4 md:-m-6" style={{ background: 'var(--bg)' }}>
        <div className="px-4 md:px-6 pt-5 pb-10"
          style={{ fontFamily: 'Urbanist, Inter, sans-serif' }}>
          {/* Заголовок лише там, де він несе НОВУ інформацію (РДН / ВДР).
              Якщо його не передали — блок відсутній разом зі своїм mb-5,
              і перший блок контенту піднімається на його місце; верхній
              відступ тримає pt-5 на контейнері. */}
          {(title || subtitle) && (
            <div className="mb-5">
              {title && (
                <h1 className="font-display text-2xl font-semibold leading-tight" style={{ color: 'var(--text)' }}>
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-[13px] mt-0.5" style={{ color: 'var(--text-muted)' }}>{subtitle}</p>
              )}
            </div>
          )}
          <OreeMarketViewRd marketFilter={marketFilter} />
        </div>
      </div>
    </DashboardLayout>
  );
}
